import { mpsEndpoints } from '../mps/mps-endpoints';

export const environment = {
  production: false,
  envName: 'dev',
  api: {
    host: 'https://apid.pwpp.iasp.tgscloud.net',
    providers: mpsEndpoints.providers,
  },
  loaderOnHttp: true,
  defaultLocale: 'en',
  allowedLanguage: ['en'],
  appName: 'PWP',
  mpsIcons: ['bin', 'edit', 'gray-edit', 'user', 'info', 'pdf', 'pdf-file', 'three-dots', 'account-circle', 'search'],
  appIcons: [],
  translationsSource: 'server',
  allowImpersonation: true,
};
